import SelectField from "controls/global/select-field";
import { showToast } from "controls/global/stewart-toast/showToast";
import React, { 
  useEffect 
} from "react";
// import { useFlashMessageV2Actions } from "utils/context/FlashMessageV2Context";
// import { useLookup } from "utils/context/LookupContext";
import { 
  useSpaceActions, 
  useSpaceLookup 
} from "utils/context/SpaceContext";
import useFormWrapper from "utils/custom-hooks/useFormWrapper";
import { TitleSearchTransacionType } from "utils/data/enum";
// import { FlashMessageType, TitleSearchTransacionType } from "utils/data/enum";

interface Props {
  schema: string;
  name: string;
  disabled?: boolean;
  onChange?: () => void;  
}

const TRANSACTION_TYPE_MESSAGE = "The Transaction Type for your Title Search differs from the file Transaction Type. Please scroll to the top of the file to update.";

const TransactionTypeField = ( {schema, name, disabled, onChange}:Props) => {
  const {setValue, getValues} = useFormWrapper();
  const [, { getTitleSearchTransactionTypes }] = useSpaceActions();
  const [{ tsTransactionTypes}] = useSpaceLookup();

  const currentTsTransactionType = getValues(name);
  const fileNameNumber = getValues("fileNameNumber");

  const handleOnChange = async (e: any, value: any) => {
    setValue(`${schema}.isDefault`, false);
    setValue(`${schema}.isTransactionTypeDirty`, true);

    // console.log(value);
    const fileTransactionTypeCode = getValues("transactionTypeCode");
    if (
      (value || "").toUpperCase() !==
        TitleSearchTransacionType.InformationOnly.toUpperCase() &&
      (value || "").toUpperCase() !== fileTransactionTypeCode
    ) {
      // showFlashMessage(
      //   FlashMessageType.Warning,
      //   "Warning!",
      //   TRANSACTION_TYPE_MESSAGE
      // );
      showToast({
        type: 'warning',
        title: 'Warning!',
        message: TRANSACTION_TYPE_MESSAGE
      });       
    }

    onChange && onChange();
  };  

  useEffect(() => {
    if (tsTransactionTypes.length > 0) {
      const productID: number = getValues(`${schema}.productID`)
      // const currentTransactionType = getValues(name);
      const fileTransactionTypeCode = getValues("transactionTypeCode");
      const isTransactionTypeDirty: boolean = getValues(
        `${schema}.isTransactionTypeDirty`
      );
      if (!isTransactionTypeDirty && productID === 0) {
        const match = tsTransactionTypes.find((ts) => ts.value.toUpperCase() === fileTransactionTypeCode);
        if (match) {
          setValue(name, match.value);
        }
      }
    }
  },[tsTransactionTypes, currentTsTransactionType]) 
  

  useEffect(function fetchSelectOptions() {
    if (tsTransactionTypes.length === 0) getTitleSearchTransactionTypes(fileNameNumber);
  }, [tsTransactionTypes, getTitleSearchTransactionTypes]);

  return (
    <SelectField
      label="Transaction Type"
      name={name}
      options={tsTransactionTypes}
      disabled={disabled}
      onChange={handleOnChange}
    />
  );
}

export default TransactionTypeField;